import type { ThemeConfig } from 'antd';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import { AttributionParamPreserver } from '@/common/component-business/attribution-param-preserver';
import { CookieConsentGate } from '@/common/component-business/cookie-consent';
import '@/global-styles.less';

// 基于参考网页的主题配置
const theme: ThemeConfig = {
  token: {
    colorPrimary: '#f50340',
    colorLink: '#f50340',
    colorLinkHover: '#f50340',
    colorBorder: '#e1e5e9',
    borderRadius: 4,
    fontSize: 14,
  },
  components: {
    Button: {
      controlHeight: 36,
      fontWeight: 600,
      // primaryShadow: '0 8px 20px rgba(255, 107, 61, 0.3)',
    },
    Input: {
      controlHeight: 36,
      colorBorder: '#e1e5e9',
      activeBorderColor: '#f50340',
      hoverBorderColor: '#f50340',
    },
    Select: {
      controlHeight: 36,
      colorBorder: '#e1e5e9',
      activeBorderColor: '#f50340',
      hoverBorderColor: '#f50340',
    },
    DatePicker: {
      controlHeight: 36,
      colorBorder: '#e1e5e9',
      activeBorderColor: '#f50340',
      hoverBorderColor: '#f50340',
    },
  },
};

export const rootContainer = (container: React.ReactElement) => {
  return (
    <ConfigProvider locale={enUS} theme={theme}>
      {container}
      <AttributionParamPreserver />
      <CookieConsentGate />
    </ConfigProvider>
  );
};
